import React from 'react';
import IndexRoutes from './routes/Index.Routes';

function App() {
  return <IndexRoutes />;
}

export default App;
